import IconSelectorModal, { IconSelectorAppIconModeProps } from './IconSelectorModal';

type AppIconPickerModalProps = Omit<IconSelectorAppIconModeProps, 'mode'>;

export default function AppIconPickerModal({ showClear = true, ...props }: AppIconPickerModalProps) {
  return <IconSelectorModal mode="appIcon" showClear={showClear} {...props} />;
}
